import { DataSourcesTypes } from '@frontend/api-data-sources';
import { contextFactory } from '@frontend/design-system';
import {
  AddToListHandlerParamsType,
  FormFields,
  PatientSelectorScreenEnum,
  PersonSelectorFormValues,
  SourceTenantListItem,
  TransformedLegacyPerson,
} from './types';

export type ManagePersonListContextType = {
  shouldRenderNotes?: boolean;
  locationId: string;
  selectedPerson: TransformedLegacyPerson | null;
  personSelectorScreen?: PatientSelectorScreenEnum;
  defaultSearchValue?: string;
  setDefaultSearchValue?: (value: string) => void;
  isLoading?: boolean;
  closePopoverDialog: () => void;
  setPersonSelectorScreen: (screen: PatientSelectorScreenEnum) => void;
  setSelectedPerson: (person: TransformedLegacyPerson | null) => void;
  onAddToListHandler?: (personDetails: AddToListHandlerParamsType) => void;
  handleAddCustomerContact?: (personDetails: PersonSelectorFormValues) => void;
  formFields: FormFields;
  clientLocationIds?: DataSourcesTypes.AccessDataResponse['ClientLocations'];
  addContactScreenTitle?: string;
  showDataSources?: boolean;
  addNewButtonTrackingId?: string;
  addToListButtonTrackingId?: string;
  cancelButtonTrackingId?: string;
  patientWritebackSourceTenants?: SourceTenantListItem[];
  shouldAddAndLink?: boolean;
};

export const [ManagePersonListContext, useManagePersonListContext] = contextFactory<ManagePersonListContextType>();
